// extracted by mini-css-extract-plugin
export default {"audioMessage":"TY0n7UXWdk8mpu72EHVl"};